"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:import-blacklist ban ban-types */
const moment_1 = __importDefault(require("moment"));
const formats_1 = require("./formats");
exports.ISO_8601 = moment_1.default.ISO_8601;
exports.setLocale = (language) => {
    moment_1.default.locale(language);
};
exports.getLocaleData = () => {
    return moment_1.default.localeData();
};
exports.isDateTime = (value) => {
    return moment_1.default.isMoment(value);
};
exports.toUtc = (input, formatInput) => {
    return moment_1.default.utc(input, formatInput);
};
exports.toDuration = (input, unit) => {
    return moment_1.default.duration(input, unit);
};
exports.dateTime = (input, formatInput) => {
    return moment_1.default(input, formatInput);
};
exports.dateTimeAsMoment = (input) => {
    return exports.dateTime(input);
};
exports.dateTimeForTimeZone = (timezone, input, formatInput) => {
    if (timezone === 'utc') {
        return exports.toUtc(input, formatInput);
    }
    return exports.dateTime(input, formatInput);
};
exports.getTimeZoneDateFormatter = timezone => (date, format) => {
    date = exports.isDateTime(date) ? date : exports.dateTime(date);
    format = format || formats_1.DEFAULT_DATE_TIME_FORMAT;
    return timezone === 'browser' ? exports.dateTime(date).format(format) : exports.toUtc(date).format(format);
};
